import { render, staticRenderFns } from "./AddOrder.vue?vue&type=template&id=a8559b88&scoped=true"
import script from "./AddOrder.vue?vue&type=script&lang=js"
export * from "./AddOrder.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8559b88",
  null
  
)

export default component.exports